import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { inputCls } from "@/lib/ui";

export const ZipInput = ({ value, onChange, testid }) => {
  const [place, setPlace] = useState("");
  useEffect(() => {
    if (!/^\d{5}$/.test(value || "")) { setPlace(""); return; }
    let live = true;
    api.get(`/geo/zip/${value}`).then(({ data }) => live && setPlace(`${data.area}, ${data.state}`)).catch(() => live && setPlace("not found"));
    return () => { live = false; };
  }, [value]);
  return (
    <div>
      <input data-testid={testid} required inputMode="numeric" pattern="\d{5}" maxLength={5} placeholder="ZIP code" value={value || ""}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 5))} className={inputCls} />
      {place && <p data-testid={`${testid}-place`} className={`text-xs mt-1 ${place === "not found" ? "text-red-600" : "text-slate-500"}`}>{place === "not found" ? "We couldn't find that US ZIP code." : place}</p>}
    </div>
  );
};
